import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import "core-js/modules/es6.function.name";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

import { Box } from '@origin-digital/layout';
import * as React from 'react';
import { textAreaFieldPropTypes } from './TextAreaField.types';
import { initialState, displayName, defaultProps, getCurrentLength } from './TextAreaField.helper';
import { Field, HelpText } from '../Field';
import { TextAreaFloatingLabelSkin as FloatingLabel, TextAreaFieldTextAreaSkin as TextArea, TextAreaFieldContainerSkin as TextAreaContainer } from './skins';

var TextAreaField =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TextAreaField, _React$Component);

  function TextAreaField(props) {
    var _this;

    _classCallCheck(this, TextAreaField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextAreaField).call(this, props));
    _this.initialState = initialState(_this.props);
    _this.state = _this.initialState;
    _this.fieldStateReducer = _this.fieldStateReducer.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }
  /**
   *
   * @param nextProps
   */


  _createClass(TextAreaField, [{
    key: "fieldStateReducer",

    /**
     * @param param
     */
    value: function fieldStateReducer(_ref) {
      var type = _ref.type,
          currentState = _ref.currentState,
          changes = _ref.changes;

      if (type === 'change') {
        var _this$props = this.props,
            maxLength = _this$props.maxLength,
            maxLengthExcludeChars = _this$props.maxLengthExcludeChars;
        var internalValue = changes.internalValue;

        if (this.props.transform) {
          internalValue = this.props.transform(internalValue, currentState.internalValue);
        }

        var _getCurrentLength = getCurrentLength(internalValue, maxLengthExcludeChars),
            currentLength = _getCurrentLength.currentLength;

        this.setState({
          currentLength: currentLength
        });
        return {
          type: type,
          currentState: currentState,
          changes: _Object$assign({}, changes, {
            internalValue: internalValue
          })
        };
      }

      return {
        type: type,
        currentState: currentState,
        changes: changes
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          disabled = _a.disabled,
          error = _a.error,
          helpText = _a.helpText,
          label = _a.label,
          maxLength = _a.maxLength,
          maxLengthExcludeChars = _a.maxLengthExcludeChars,
          maxLengthToDisplay = _a.maxLengthToDisplay,
          name = _a.name,
          onBlur = _a.onBlur,
          onChange = _a.onChange,
          onFocus = _a.onFocus,
          renderOverlay = _a.renderOverlay,
          showCharacterCount = _a.showCharacterCount,
          spinner = _a.spinner,
          skinType = _a.skinType,
          tabIndex = _a.tabIndex,
          touched = _a.touched,
          value = _a.value,
          width = _a.width,
          height = _a.height,
          setInputRef = _a.setInputRef,
          transform = _a.transform,
          dataId = _a['data-id'],
          rest = __rest(_a, ["disabled", "error", "helpText", "label", "maxLength", "maxLengthExcludeChars", "maxLengthToDisplay", "name", "onBlur", "onChange", "onFocus", "renderOverlay", "showCharacterCount", "spinner", "skinType", "tabIndex", "touched", "value", "width", "height", "setInputRef", "transform", 'data-id']);

      var currentLength = this.state.currentLength;
      return React.createElement(Field, {
        name: name,
        error: error,
        value: value,
        width: width,
        height: height,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        touched: touched,
        stateReducer: this.fieldStateReducer,
        setInputRef: setInputRef,
        "data-id": dataId
      }, function (_ref2) {
        var _ref2$meta = _ref2.meta,
            touched = _ref2$meta.touched,
            valid = _ref2$meta.valid,
            active = _ref2$meta.active,
            xClickLast = _ref2$meta.xClickLast,
            showError = _ref2$meta.showError,
            input = _ref2.input;
        var floatAbove = active || touched && !active && input.value !== '' || input.value !== '';
        return React.createElement(Box, {
          display: "flex",
          direction: "column",
          width: "100%",
          height: "100%"
        }, React.createElement(TextAreaContainer, {
          width: "100%",
          height: "100%",
          disabled: disabled
        }, React.createElement(TextArea, _extends({}, rest, {
          active: active,
          disabled: disabled,
          innerRef: setInputRef,
          maxLength: maxLength,
          onBlur: input.onBlur,
          onChange: input.onChange,
          onFocus: input.onFocus,
          showError: showError,
          tabIndex: disabled ? -1 : tabIndex,
          value: input.value,
          "data-id": name + 'TextArea'
        })), React.createElement(FloatingLabel, {
          disabled: disabled,
          floatAbove: floatAbove,
          active: active,
          showError: showError
        }, label)), React.createElement(HelpText, {
          name: name,
          disabled: disabled,
          showError: showError,
          error: error,
          helpText: helpText,
          characterCount: showCharacterCount && maxLength !== 524288 && {
            currentLength: currentLength,
            maxLength: isNaN(maxLengthToDisplay) ? maxLength : maxLengthToDisplay
          }
        }));
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      return _Object$assign({}, getCurrentLength(nextProps.value, nextProps.maxLengthExcludeChars));
    }
  }]);

  return TextAreaField;
}(React.Component);

TextAreaField.propTypes = textAreaFieldPropTypes;
TextAreaField.displayName = displayName;
TextAreaField.defaultProps = defaultProps;
export { TextAreaField };